import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import ContentUrl from 'content-management-details-lib/components/ContentUrl';
import useCrmDynamicObjects from '../hooks/useCrmDynamicObjects';
import useDynamicPageInfo from '../hooks/useDynamicPageInfo';
import useHubDbContentUrl from '../hooks/useHubDbContentUrl';
import useRouteParams from '../hooks/useRouteParams';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmDynamicPageUrl = ({
  contentObject,
  absoluteUrl
}) => {
  const {
    crmObjectId,
    crmObjectTypeId
  } = useDynamicPageInfo();
  const propertyForDynamicPageSlug = getContentPropertyValue(contentObject, 'hs_property_for_dynamic_page_slug');
  const {
    crmDynamicPageSlug
  } = useCrmDynamicObjects({
    crmObjectId,
    crmObjectTypeId,
    propertyForDynamicPageSlug
  });
  const url = crmDynamicPageSlug ? `${absoluteUrl}/${crmDynamicPageSlug}` : absoluteUrl;
  return /*#__PURE__*/_jsx(ContentUrl, {
    contentDisplayUrl: url,
    displayShareablePreviewURL: url
  });
};
const HubDbPageUrl = ({
  absoluteUrl
}) => {
  const {
    contentId: contentIdParam
  } = useRouteParams();
  const {
    hubDbContentUrl
  } = useHubDbContentUrl({
    pageId: contentIdParam
  });
  const url = hubDbContentUrl || absoluteUrl;
  return /*#__PURE__*/_jsx(ContentUrl, {
    contentDisplayUrl: url,
    displayShareablePreviewURL: url
  });
};
const PageUrl = ({
  contentObject
}) => {
  const {
    isCrmDynamicPage,
    isHubDbPage
  } = useDynamicPageInfo();
  const absoluteUrl = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.ABSOLUTE_URL);
  if (isHubDbPage) {
    return /*#__PURE__*/_jsx(HubDbPageUrl, {
      absoluteUrl: absoluteUrl
    });
  } else if (isCrmDynamicPage) {
    return /*#__PURE__*/_jsx(CrmDynamicPageUrl, {
      absoluteUrl: absoluteUrl,
      contentObject: contentObject
    });
  }
  return /*#__PURE__*/_jsx(ContentUrl, {
    contentDisplayUrl: absoluteUrl,
    displayShareablePreviewURL: absoluteUrl
  });
};
export default PageUrl;